class MessageSound {
    constructor() {
        this.audio = null;
        this.isLoaded = false;
        this.loadSound();
    }

    loadSound() {
        try {
            // You can place message.mp3 in public/sounds/ directory
            this.audio = new Audio('/sounds/message.mp3');
            this.audio.preload = 'auto';

            this.audio.addEventListener('canplaythrough', () => {
                this.isLoaded = true;
            });

            this.audio.addEventListener('error', (e) => {
                console.warn('Failed to load message sound:', e);
            });
        } catch (error) {
            console.warn('Audio not supported:', error);
        }
    }

    play(volume = 0.7) {
        if (!this.audio || !this.isLoaded) return;

        try {
            // Check if muted
            const isMuted = localStorage.getItem('messageMuted') === 'true';
            if (isMuted) return;

            // Set volume BEFORE playing
            this.audio.volume = Math.max(0, Math.min(1, volume));

            // Reset audio to beginning and play
            this.audio.currentTime = 0;
            this.audio.play().catch(e => {
                console.warn('Could not play message sound:', e);
            });
        } catch (error) {
            console.warn('Error playing message sound:', error);
        }
    }

    // Test the sound with current settings
    testSound() {
        const volume = parseFloat(localStorage.getItem('messageVolume') || '0.7');
        this.play(volume);
    }
}

// Create singleton instance
const messageSound = new MessageSound();

export default messageSound;
